import { render, staticRenderFns } from "./RelatedPrice.vue?vue&type=template&id=030b38a6&"
import script from "./RelatedPrice.vue?vue&type=script&lang=js&"
export * from "./RelatedPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports